import React, { useEffect, useState } from 'react';
import { api } from '../../services/api';

export default function CommsHealthWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.getCommsHealth();
        setData(res);
      } catch (e) {
        setError(e?.message || 'Failed to load comms health');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div style={styles.card}>
        <div style={styles.title}>📨 Comms Health</div>
        <div style={styles.muted}>Loading…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.card}>
        <div style={styles.title}>📨 Comms Health</div>
        <div style={{ ...styles.muted, color: '#f87171' }}>{error}</div>
      </div>
    );
  }

  const smsEnabled = !!data?.sms_enabled;

  return (
    <div style={styles.card}>
      <div style={styles.headerRow}>
        <div style={styles.title}>📨 Comms Health</div>
        <div style={{
          ...styles.badge,
          background: smsEnabled ? '#064e3b' : '#7f1d1d',
          borderColor: smsEnabled ? '#10b981' : '#ef4444',
          color: smsEnabled ? '#a7f3d0' : '#fecaca',
        }}>
          {smsEnabled ? 'SMS Enabled' : 'SMS Not Ready'}
        </div>
      </div>

      <div style={styles.grid}>
        <Field label="Region" value={data?.region || '—'} />
        <Field label="Shared Number" value={data?.shared_number_e164 || '—'} />
        <Field label="Last Inbound" value={fmtDate(data?.last_inbound_at)} />
        <Field label="Last Outbound" value={fmtDate(data?.last_outbound_at)} />
        <Field label="Last Outbound Status" value={data?.last_outbound_status || '—'} />
      </div>

      <div style={styles.note}>
        This is read-only. Provisioning is handled by Tucana ops.
      </div>
    </div>
  );
}

function Field({ label, value }) {
  return (
    <div style={styles.field}>
      <div style={styles.label}>{label}</div>
      <div style={styles.value}>{value}</div>
    </div>
  );
}

function fmtDate(v) {
  if (!v) return '—';
  try {
    const d = new Date(v);
    return d.toLocaleString();
  } catch {
    return String(v);
  }
}

const styles = {
  card: {
    background: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '16px',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    marginBottom: '12px',
  },
  title: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#f1f5f9',
  },
  badge: {
    fontSize: '12px',
    fontWeight: '700',
    padding: '6px 10px',
    borderRadius: '999px',
    border: '1px solid',
    whiteSpace: 'nowrap',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '12px',
  },
  field: {
    background: '#0f172a',
    border: '1px solid #334155',
    borderRadius: '10px',
    padding: '10px 12px',
  },
  label: {
    fontSize: '12px',
    color: '#94a3b8',
    marginBottom: '4px',
  },
  value: {
    fontSize: '14px',
    color: '#e2e8f0',
    wordBreak: 'break-word',
  },
  muted: {
    color: '#94a3b8',
    fontSize: '13px',
  },
  note: {
    marginTop: '12px',
    color: '#94a3b8',
    fontSize: '12px',
  },
};
